import React, { useContext, useState } from 'react';
import { Button, Input, radio } from '@material-tailwind/react';
import MaskList from './components/MaskList';
import { ControlVideoProps } from './components/helpers/Interfaces';
import { ControlContext } from './components/hooks/createContext';
import { onnxMaskToImage } from './components/helpers/maskUtils';
import { clear } from 'console';
const _ = require('lodash');
const axios = require("axios");
const SERVER_URL = "https://ai4sports.opengvlab.com/interp/api";

const ControlVideoApp = ({updateLoader, videoPath, shouldFitWidth} : ControlVideoProps) => {
//   const {
//     controls: [controls, setControls],
//     selectedIndices: [selectedIndices, setSelectedIndices]
//   } = useContext(ControlContext)!;

//   const handleCombineDelete = (index: number) => {
//     handleDelete(index);
//     const newControls = [...controls];
//     newControls.splice(index,1)
//     setControls(newControls);
//   };
const [Fps, setFps] = useState('');
  const [videoUrl, setVideoUrl] = useState('');
  const [interpRate, setInterpRate] = useState("2");
//   const [samplingPoints, setSamplingPoints] = useState('30');

//   const combineMasks = () => {
//     console.log("vatran combineMasks", selectedIndices, masks.length)

//     let unselectedMasks = [];

//     const first = selectedIndices[0]
    
//     // for control update
//     const newControls = [...controls].filter(function(v, i) {
//       return selectedIndices.indexOf(i) < 0
//     });
    

//     const combinedControl = controls[first];


//     const resultMask: modelMaskProps = {
//       id: masks[first].id,
//       name: masks[first].name,
//       maskImg: masks[first].maskImg,
//       rawMask: {
//         width: masks[first].rawMask.width,
//         height: masks[first].rawMask.height,
//         data: masks[first].rawMask.data,
//       }
//     }
//     const length = resultMask.rawMask.data.length;
//     for (let i = 1; i < selectedIndices.length; i++) {
//       const data = masks[selectedIndices[i]].rawMask.data;

//       for (let j = 0; j < length; j++) {
//         if (data[j] > 0) {
//           resultMask.rawMask.data[j] = 1;
//         }
//       }
//     }
//     newControls.unshift(combinedControl);
//     setControls(newControls); // update controls after combining

//     // update maskImg of resultMask
//     resultMask.maskImg = onnxMaskToImage(
//       resultMask.rawMask.data, 
//       resultMask.rawMask.height, 
//       resultMask.rawMask.width
//     );

//     // the combined
//     unselectedMasks.push(resultMask);

//     // plus the unselected
//     for (let i = 0; i < masks.length; i++) {
//       if (selectedIndices.indexOf(i) < 0) {
//         unselectedMasks.push(masks[i])
//       }
//     }
    
//     updateMasks(unselectedMasks)
//     // reset selected indices after merge
//     setSelectedIndices([])
//   }
  

  const interpolateVideo = () => {
    clearInterpVideo();
    // show loading
    updateLoader(true);
    console.log("vatran filenames", videoPath)

    const fileData = JSON.stringify(
        {
            sampling_points: interpRate,
            video_url: videoPath,
            fps:Fps
        }
      );
    
    const blob = new Blob([fileData], { type: "text/plain" });
    const url = URL.createObjectURL(blob);

    // create form data to upload mask_dict
    let formData = new FormData();
    formData.append("file", blob);


    axios.post(`${SERVER_URL}/interpolate_video`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response: any) => {
        updateLoader(false);
        setVideoUrl(response['data']['video_url'])
      }, (error: any) => {
        console.log(error);
        updateLoader(false);
      });
    }
  

  const clearInterpVideo = ()=>{
    setVideoUrl("")
  }

  const onSetInterpRate = (event:React.ChangeEvent<HTMLInputElement>) =>{
    console.log(event.target.value)
    setInterpRate(event.target.value)
  }
  

  const reshape = (array: Uint8ClampedArray, width: number) => {
    const inputArr = Array.from(array)
    const newArr = [];
    while(inputArr.length) newArr.push(inputArr.splice(0,width));
    return newArr;
  }
  const handleFpsChange = (event: React.FormEvent<HTMLInputElement>) => {
    if(parseInt(event.currentTarget.value) >= 100){
      setFps('99');
    }else{
      setFps(event.currentTarget.value);
    }
    //setFps(event.currentTarget.value);
  };

//   const handleSamplingChange = (event: React.FormEvent<HTMLInputElement>) => {
//     setSamplingPoints(event.currentTarget.value);
//   };
const flexCenterClasses = "flex items-center justify-center";
const imageClasses = "";
// const shouldFitToWidth = false;
  return (
    <div className="column h-full">
      <div className="row scrollbable">
        {/* <Button className="m-2" size="md" onClick={combineMasks} disabled={selectedIndices.length <= 1} onResize={undefined} onResizeCapture={undefined}>Combine Masks</Button> */}
        <Button className="m-2" size="md" onClick={interpolateVideo} disabled={videoPath == ""} onResize={undefined} onResizeCapture={undefined}>Interpolate</Button>
        <Button className="m-2" size="md" onClick={clearInterpVideo} onResize={undefined} onResizeCapture={undefined}>Clear</Button>
        
        <div className="w-12 m-2">
            <Input className='w-12' size="md" label="Target FPS" type="number" maxLength={2} onChange={handleFpsChange} value={Fps} onResize={undefined} onResizeCapture={undefined} crossOrigin={undefined}/>
        </div>
        <div className="m-2" onChange={onSetInterpRate}>
            <input type='radio' value="2" name='interpRate' className='ml-4' checked={interpRate=='2'}  onChange={onSetInterpRate}/> x2   
            <input type='radio' value="4" name='interpRate' className='ml-4' checked={interpRate=='4'} onChange={onSetInterpRate} /> x4   
            <input type='radio' value="8" name='interpRate' className='ml-4' checked={interpRate=='8'} onChange={onSetInterpRate}/> x8   
        </div>
        {videoUrl && videoUrl.length > 0 &&
        //   <div className="m-2">
        //     <video controls width="80%"><source src={videoUrl} type="video/mp4"/></video>
        //   </div>
        <div className="row h-[80%] mb-8">
        <div className={`${flexCenterClasses} w-full h-full`}>
        <div className={`${flexCenterClasses} relative w-[90%] h-[95%]`}>
        <div className={`${flexCenterClasses} relative w-full h-full image-container`}>
                {/* <img src='/images/close_button.png' className='close-button' onClick={clearVideo}/> */}
               
                <video controls src={videoUrl} className={`${
                    shouldFitWidth ? "w-full" : "h-full"
                  } ${imageClasses}`}

                  ></video>
        </div>
        </div>
        </div>
        </div>
        }
        {/* <MaskList masks={masks} handleDelete={handleCombineDeletzhone}/> */}
      </div>
    </div>
  );
}

export default ControlVideoApp;